// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio-matrix-modal .modal-dialog {
    max-width: 95vw;
    max-height: 90vh;
}

.portfolio-matrix-modal .modal-content {
    max-height: 90vh;
    display: flex;
    flex-direction: column;
}

.portfolio-matrix-modal .modal-body {
    flex: 1 1;
    overflow: hidden;
}

/* Botão X do header */
.portfolio-matrix-modal .modal-header .btn-close {
    filter: invert(1) grayscale(100%) brightness(200%);
    opacity: 0.8;
}

.portfolio-matrix-modal .modal-header .btn-close:hover {
    opacity: 1;
}

/* Toolbar */
.portfolio-matrix-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 1px;
    /* background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb; */
    gap: 12px;
}

.toolbar-search-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1;
}

.toolbar-search {
    display: flex;
    align-items: center;
    position: relative;
    flex: 1 1;
    max-width: 350px;
}

.search-icon {
    position: absolute;
    left: 10px;
    width: 18px;
    height: 18px;
    color: #9ca3af;
    pointer-events: none;
}

.search-input {
    flex: 1 1;
    padding: 6px 12px 6px 36px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 13px;
    outline: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.search-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-input:focus + .search-icon {
    color: #3b82f6;
}

.clear-search-button {
    position: absolute;
    right: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    background-color: transparent;
    color: #6b7280;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.clear-search-button:hover {
    background-color: #f3f4f6;
    color: #374151;
}

.clear-all-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    background-color: #ef4444;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    transition: background-color 0.15s ease;
}

.clear-all-button:hover {
    background-color: #dc2626;
}

.portfolio-matrix-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.portfolio-matrix-scroll-container {
    overflow: auto;
    max-height: calc(90vh - 260px);
    border: 1px solid #e5e7eb;
    border-radius: 8px;
}

/* Scrollbar styling */
.portfolio-matrix-scroll-container::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.portfolio-matrix-scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.portfolio-matrix-scroll-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 5px;
}

.portfolio-matrix-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.portfolio-matrix-table {
    width: auto;
    border-collapse: collapse;
    font-size: 11px;
    background: white;
}

/* Sticky corner (top-left cell) */
.sticky-corner {
    position: sticky;
    left: 0;
    top: 0;
    z-index: 30;
    background-color: #1f2937;
    color: white;
    border: 1px solid #d1d5db;
    padding: 6px 8px;
    text-align: center;
    font-weight: 700;
    font-size: 11px;
    min-width: 140px;
    max-width: 140px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
}

/* Column headers - sticky top and move horizontally */
.portfolio-header {
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: #f9fafb;
    border: 1px solid #d1d5db;
    padding: 4px 2px;
    text-align: center;
    min-width: 32px;
    max-width: 32px;
    writing-mode: vertical-rl;
    text-orientation: mixed;
}


.portfolio-header-text {
    font-weight: 600;
    color: #374151;
    font-size: 10px;
}

/* Row headers - sticky left and move vertically */
.portfolio-row-header {
    position: sticky;
    left: 0;
    z-index: 15;
    background-color: #f9fafb;
    border: 1px solid #d1d5db;
    padding: 4px 6px;
    font-weight: 500;
    min-width: 140px;
    max-width: 140px;
}


/* Destaque de busca - sem animação */
.portfolio-row-header.search-highlighted {
    background-color: #fbbf24 !important;
}

.portfolio-row-header.search-highlighted .portfolio-id,
.portfolio-row-header.search-highlighted .portfolio-name {
    color: #78350f;
    font-weight: 700;
}

/* Destaque de célula específica */
.portfolio-cell.cell-highlighted {
    background-color: #10b981 !important;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.5);
    position: relative;
    z-index: 10;
}

.portfolio-cell.cell-highlighted .checkbox-wrapper {
    border-color: white;
    box-shadow: 0 0 8px rgba(16, 185, 129, 0.6);
}

.portfolio-row-header-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.portfolio-id {
    font-weight: 700;
    color: #003B6B;
    font-size: 11px;
}

.portfolio-name {
    font-size: 9px;
    color: #6b7280;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Data cells */
.portfolio-cell {
    border: 1px solid #d1d5db;
    padding: 2px;
    text-align: center;
    cursor: pointer;
    min-width: 32px;
    max-width: 32px;
    height: 32px;
    background-color: white;
}


.portfolio-cell.diagonal {
    background-color: #f3f4f6;
    cursor: not-allowed;
    opacity: 0.7;
}

/* Checkbox styling */
.checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: 1.5px solid #d1d5db;
    border-radius: 3px;
    background-color: white;
}

.checkbox-wrapper.checked {
    background-color: #003B6B;
    border-color: #003B6B;
}

.checkbox-wrapper .check-icon {
    color: white;
    width: 14px;
    height: 14px;
}

/* Prevent text selection while clicking cells */
.portfolio-matrix-table {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/portfolioMatrix.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,kDAAkD;IAClD,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB;uCACmC;IACnC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,SAAO;IACP,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,0DAA0D;AAC9D;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA,sDAAsD;AACtD;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,uBAAuB;AAC3B;;;AAGA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,kDAAkD;AAClD;IACI,gBAAgB;IAChB,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA,qCAAqC;AACrC;IACI,oCAAoC;AACxC;;AAEA;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,oCAAoC;IACpC,6CAA6C;IAC7C,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;;;AAGA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA,gDAAgD;AAChD;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;AACzB","sourcesContent":[".portfolio-matrix-modal .modal-dialog {\n    max-width: 95vw;\n    max-height: 90vh;\n}\n\n.portfolio-matrix-modal .modal-content {\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.portfolio-matrix-modal .modal-body {\n    flex: 1;\n    overflow: hidden;\n}\n\n/* Botão X do header */\n.portfolio-matrix-modal .modal-header .btn-close {\n    filter: invert(1) grayscale(100%) brightness(200%);\n    opacity: 0.8;\n}\n\n.portfolio-matrix-modal .modal-header .btn-close:hover {\n    opacity: 1;\n}\n\n/* Toolbar */\n.portfolio-matrix-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 1px;\n    /* background-color: #f9fafb;\n    border-bottom: 1px solid #e5e7eb; */\n    gap: 12px;\n}\n\n.toolbar-search-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n}\n\n.toolbar-search {\n    display: flex;\n    align-items: center;\n    position: relative;\n    flex: 1;\n    max-width: 350px;\n}\n\n.search-icon {\n    position: absolute;\n    left: 10px;\n    width: 18px;\n    height: 18px;\n    color: #9ca3af;\n    pointer-events: none;\n}\n\n.search-input {\n    flex: 1;\n    padding: 6px 12px 6px 36px;\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    font-size: 13px;\n    outline: none;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.search-input:focus {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.search-input:focus + .search-icon {\n    color: #3b82f6;\n}\n\n.clear-search-button {\n    position: absolute;\n    right: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px;\n    background-color: transparent;\n    color: #6b7280;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.clear-search-button:hover {\n    background-color: #f3f4f6;\n    color: #374151;\n}\n\n.clear-all-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px 12px;\n    background-color: #ef4444;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 500;\n    transition: background-color 0.15s ease;\n}\n\n.clear-all-button:hover {\n    background-color: #dc2626;\n}\n\n.portfolio-matrix-wrapper {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.portfolio-matrix-scroll-container {\n    overflow: auto;\n    max-height: calc(90vh - 260px);\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n}\n\n/* Scrollbar styling */\n.portfolio-matrix-scroll-container::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n}\n\n.portfolio-matrix-scroll-container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 5px;\n}\n\n.portfolio-matrix-scroll-container::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 5px;\n}\n\n.portfolio-matrix-scroll-container::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n.portfolio-matrix-table {\n    width: auto;\n    border-collapse: collapse;\n    font-size: 11px;\n    background: white;\n}\n\n/* Sticky corner (top-left cell) */\n.sticky-corner {\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 30;\n    background-color: #1f2937;\n    color: white;\n    border: 1px solid #d1d5db;\n    padding: 6px 8px;\n    text-align: center;\n    font-weight: 700;\n    font-size: 11px;\n    min-width: 140px;\n    max-width: 140px;\n    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Column headers - sticky top and move horizontally */\n.portfolio-header {\n    position: sticky;\n    top: 0;\n    z-index: 20;\n    background-color: #f9fafb;\n    border: 1px solid #d1d5db;\n    padding: 4px 2px;\n    text-align: center;\n    min-width: 32px;\n    max-width: 32px;\n    writing-mode: vertical-rl;\n    text-orientation: mixed;\n}\n\n\n.portfolio-header-text {\n    font-weight: 600;\n    color: #374151;\n    font-size: 10px;\n}\n\n/* Row headers - sticky left and move vertically */\n.portfolio-row-header {\n    position: sticky;\n    left: 0;\n    z-index: 15;\n    background-color: #f9fafb;\n    border: 1px solid #d1d5db;\n    padding: 4px 6px;\n    font-weight: 500;\n    min-width: 140px;\n    max-width: 140px;\n}\n\n\n/* Destaque de busca - sem animação */\n.portfolio-row-header.search-highlighted {\n    background-color: #fbbf24 !important;\n}\n\n.portfolio-row-header.search-highlighted .portfolio-id,\n.portfolio-row-header.search-highlighted .portfolio-name {\n    color: #78350f;\n    font-weight: 700;\n}\n\n/* Destaque de célula específica */\n.portfolio-cell.cell-highlighted {\n    background-color: #10b981 !important;\n    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.5);\n    position: relative;\n    z-index: 10;\n}\n\n.portfolio-cell.cell-highlighted .checkbox-wrapper {\n    border-color: white;\n    box-shadow: 0 0 8px rgba(16, 185, 129, 0.6);\n}\n\n.portfolio-row-header-content {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.portfolio-id {\n    font-weight: 700;\n    color: #003B6B;\n    font-size: 11px;\n}\n\n.portfolio-name {\n    font-size: 9px;\n    color: #6b7280;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Data cells */\n.portfolio-cell {\n    border: 1px solid #d1d5db;\n    padding: 2px;\n    text-align: center;\n    cursor: pointer;\n    min-width: 32px;\n    max-width: 32px;\n    height: 32px;\n    background-color: white;\n}\n\n\n.portfolio-cell.diagonal {\n    background-color: #f3f4f6;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n/* Checkbox styling */\n.checkbox-wrapper {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    border: 1.5px solid #d1d5db;\n    border-radius: 3px;\n    background-color: white;\n}\n\n.checkbox-wrapper.checked {\n    background-color: #003B6B;\n    border-color: #003B6B;\n}\n\n.checkbox-wrapper .check-icon {\n    color: white;\n    width: 14px;\n    height: 14px;\n}\n\n/* Prevent text selection while clicking cells */\n.portfolio-matrix-table {\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
